/* ============================================================
   ZOELLA STUDIOS — Theme JavaScript
   Built for Shopify 2.0 — Theme Editor + App Compatibility
   ============================================================ */

'use strict';


  // ---- Developer signature ----
  (function () {
    try {
      var art = String.raw`
   _____   _ ___ ___ _  _ ___ __  __  ___
  |_   _| | | __| _ \ \| / __|  \/  |/ _ \
    | || || | _||   / .  \__ \ |\/| | (_) |
    |_| \__/|___|_|_\_|\_|___/_|  |_|\___/

   ___  _____   _____ _    ___  ___ __  __ ___ _  _ _____
  |   \| __\ \ / / __| |  / _ \| _ \  \/  | __| \| |_   _|
  | |) | _| \ V /| _|| |_| (_) |  _/ |\/| | _|| .  | | |
  |___/|___| \_/ |___|____\___/|_| |_|  |_|___|_|\_| |_|
          Custom theme by Jonas Hollund Tjernsmo
  `;
      console.log("%c" + art, "color:#00391C;font-weight:bold;");
    } catch (e) {}
  })();



// ---- Utilities ----
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

/** Dispatch a custom event — many apps listen for these */
function dispatch(name, detail = {}, target = document) {
  target.dispatchEvent(new CustomEvent(name, { bubbles: true, detail }));
}

// ---- Cart State ----
let cart = window.cartData || { items: [], item_count: 0, total_price: 0 };

// ---- Money Formatting ----
function formatMoney(cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  cents = parseInt(cents, 10) || 0;
  const value = (cents / 100).toFixed(2);
  const valueComma = value.replace('.', ',');
  const noDecimals = String(Math.round(cents / 100));
  const noDecimalsComma = noDecimals;
  const fmt = format || window.moneyFormat || '{{ amount }} kr';
  return fmt
    .replace('{{amount_with_comma_separator}}', valueComma)
    .replace('{{ amount_with_comma_separator }}', valueComma)
    .replace('{{amount_no_decimals_with_comma_separator}}', noDecimalsComma)
    .replace('{{ amount_no_decimals_with_comma_separator }}', noDecimalsComma)
    .replace('{{amount_no_decimals}}', noDecimals)
    .replace('{{ amount_no_decimals }}', noDecimals)
    .replace('{{amount}}', value)
    .replace('{{ amount }}', value);
}

/**
 * Re-run the currency converter (e.g. Bucks) on freshly rendered prices.
 * Newly injected prices are in the shop currency (NOK); this converts them to the
 * visitor's selected currency. Standard pattern for AJAX-updated `.money` elements.
 */
function reconvertCurrency() {
  try {
    if (window.Currency && typeof window.Currency.convertAll === 'function') {
      const shop = window.Currency.shopCurrency
        || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
        || 'NOK';
      const target = window.Currency.currentCurrency
        || (window.Currency.cookie && window.Currency.cookie.read && window.Currency.cookie.read('currency'))
        || shop;
      if (target && target !== shop) window.Currency.convertAll(shop, target);
    }
  } catch (e) { /* currency app not present — prices stay in shop currency */ }
  // Generic hook in case the app listens for DOM/price refreshes
  document.dispatchEvent(new CustomEvent('theme:prices:updated', { bubbles: true }));
}

// ============================================================
// HEADER — MEGA MENU
// ============================================================
function initMegaMenu() {
  const trigger = $('#nav-trigger');
  const menu = $('#mega-menu');
  if (!trigger || !menu) return;

  let closeTimer = null;

  function openMenu() {
    clearTimeout(closeTimer);
    menu.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
  }

  function closeMenu() {
    closeTimer = setTimeout(() => {
      menu.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }, 150);
  }

  on(trigger, 'mouseenter', openMenu);
  on(trigger, 'mouseleave', closeMenu);
  on(menu, 'mouseenter', () => clearTimeout(closeTimer));
  on(menu, 'mouseleave', closeMenu);
  on(trigger, 'click', () => menu.classList.contains('is-open') ? closeMenu() : openMenu());

  on(document, 'keydown', e => {
    if (e.key === 'Escape') closeMenu();
  });
  on(document, 'click', e => {
    if (!trigger.contains(e.target) && !menu.contains(e.target)) {
      menu.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.setAttribute('aria-hidden', 'true');
    }
  });
}

// ============================================================
// MOBILE MENU
// ============================================================
function initMobileMenu() {
  const trigger = $('#nav-trigger');
  const menu = $('#mobile-menu');
  const overlay = $('#mobile-overlay');
  const closeBtn = $('#mobile-close');
  if (!menu) return;

  function isMobile() { return window.innerWidth <= 768; }

  function openMobile() {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    overlay.style.display = 'block';
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
  }

  function closeMobile() {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-open');
    setTimeout(() => { if (overlay) overlay.style.display = ''; }, 300);
    document.body.style.overflow = '';
    trigger && trigger.focus();
  }

  on(trigger, 'click', () => { if (isMobile()) openMobile(); });
  on(closeBtn, 'click', closeMobile);
  on(overlay, 'click', closeMobile);
  on(document, 'keydown', e => { if (e.key === 'Escape') closeMobile(); });

  // Mobile sub-menu accordion
  $$('.mobile-menu__cat-btn').forEach(btn => {
    on(btn, 'click', () => {
      const subId = btn.getAttribute('aria-controls');
      const sub = $('#' + subId);
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isExpanded));
      if (sub) sub.hidden = isExpanded;
    });
  });
}

// ============================================================
// COUNTDOWN DROP
// ============================================================
function initCountdown() {
  $$('[data-countdown-timer]').forEach(timer => {
    const targetSec = parseInt(timer.dataset.target, 10);
    if (!targetSec) return;
    const targetMs = targetSec * 1000;
    const dEl = timer.querySelector('[data-days]');
    const hEl = timer.querySelector('[data-hours]');
    const mEl = timer.querySelector('[data-minutes]');
    const sEl = timer.querySelector('[data-seconds]');
    const pad = n => String(n).padStart(2, '0');
    let reloaded = false;

    function tick() {
      const diff = targetMs - Date.now();
      if (diff <= 0) {
        if (dEl) dEl.textContent = '00';
        if (hEl) hEl.textContent = '00';
        if (mEl) mEl.textContent = '00';
        if (sEl) sEl.textContent = '00';
        clearInterval(iv);
        // The drop just went live — reload so the server renders the products.
        if (!reloaded) { reloaded = true; window.location.reload(); }
        return;
      }
      const total = Math.floor(diff / 1000);
      if (dEl) dEl.textContent = pad(Math.floor(total / 86400));
      if (hEl) hEl.textContent = pad(Math.floor((total % 86400) / 3600));
      if (mEl) mEl.textContent = pad(Math.floor((total % 3600) / 60));
      if (sEl) sEl.textContent = pad(total % 60);
    }

    tick();
    const iv = setInterval(tick, 1000);
  });
}

// ============================================================
// SEARCH OVERLAY
// ============================================================
function initSearch() {
  const trigger = $('#search-trigger');
  const overlay = $('#search-overlay');
  const closeBtn = $('#search-close');
  const input = $('#search-input');
  if (!trigger || !overlay) return;

  function openSearch() {
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input && input.focus(), 50);
  }
  function closeSearch() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    trigger.focus();
  }

  on(trigger, 'click', openSearch);
  on(closeBtn, 'click', closeSearch);
  on(overlay, 'click', e => { if (e.target === overlay) closeSearch(); });
  on(document, 'keydown', e => {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closeSearch();
  });
}

// ============================================================
// CART DRAWER
// ============================================================
function initCartDrawer() {
  const drawer = $('#cart-drawer');
  const trigger = $('#cart-trigger');
  const closeBtn = $('#cart-close');
  const overlay = $('#cart-overlay');
  const continueBtn = $('#cart-continue');
  if (!drawer) return;

  function openCart() {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn && closeBtn.focus();
    dispatch('cart:opened');
  }

  function closeCart() {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    trigger && trigger.focus();
    dispatch('cart:closed');
  }

  on(trigger, 'click', openCart);
  on(closeBtn, 'click', closeCart);
  on(overlay, 'click', closeCart);
  on(continueBtn, 'click', closeCart);
  on(document, 'keydown', e => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeCart();
  });

  // Discount toggle (show/hide the input)
  const discountToggle = $('#discount-toggle');
  const discountForm = $('#discount-form');
  if (discountToggle && discountForm) {
    on(discountToggle, 'click', () => {
      const isExpanded = discountToggle.getAttribute('aria-expanded') === 'true';
      discountToggle.setAttribute('aria-expanded', String(!isExpanded));
      discountForm.hidden = isExpanded;
      if (!isExpanded) $('#discount-input')?.focus();
    });
  }

  // Discount apply
  const discountInput = $('#discount-input');
  const discountApply = $('#discount-apply');
  const discountError = $('#discount-error');

  function showDiscountError(msg) {
    if (!discountError) return;
    discountError.textContent = msg;
    discountError.hidden = false;
  }
  function clearDiscountError() {
    if (!discountError) return;
    discountError.textContent = '';
    discountError.hidden = true;
  }

  async function submitDiscount() {
    const code = (discountInput?.value || '').trim();
    if (!code || !discountApply) return;
    clearDiscountError();
    discountApply.disabled = true;
    discountApply.textContent = '…';
    try {
      await applyDiscountCode(code);
      discountInput.value = '';
    } catch (err) {
      showDiscountError(err.message || 'Could not apply code.');
    } finally {
      discountApply.disabled = false;
      discountApply.textContent = 'Apply';
    }
  }

  on(discountApply, 'click', submitDiscount);
  on(discountInput, 'keydown', e => {
    if (e.key === 'Enter') { e.preventDefault(); submitDiscount(); }
  });
  on(discountInput, 'input', clearDiscountError);

  // Remove an applied discount (event delegation)
  on(document, 'click', async e => {
    const btn = e.target.closest('.cart-discount__remove[data-code]');
    if (!btn) return;
    btn.disabled = true;
    try {
      await removeDiscountCode(btn.dataset.code);
    } catch (err) {
      showDiscountError(err.message || 'Could not remove code.');
      btn.disabled = false;
    }
  });

  // Qty +/- and Remove inside cart drawer (event delegation)
  on(document, 'click', async e => {
    const btn = e.target.closest('[data-action]');
    if (!btn || !btn.closest('#cart-drawer-body')) return;
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    if (!key) return;

    if (action === 'remove') {
      await updateCartItem(key, 0);
      return;
    }
    if (action === 'increase' || action === 'decrease') {
      const currentQty = parseInt(btn.closest('.cart-item')?.querySelector('.qty-value')?.textContent || '1', 10);
      const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
      await updateCartItem(key, newQty);
    }
  });

  window.openCartDrawer = openCart;
  window.closeCartDrawer = closeCart;
}

// ============================================================
// CART API HELPERS
// ============================================================
async function fetchCart() {
  const res = await fetch('/cart.js');
  const data = await res.json();
  return data;
}

async function addToCart(variantId, quantity = 1, properties = {}) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity, properties })
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.description || err.message || 'Could not add to cart');
  }
  return res.json();
}

async function updateCartItem(key, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  const updatedCart = await res.json();
  updateCartUI(updatedCart);

  // Fire event for apps (e.g., upsell, analytics)
  dispatch('cart:updated', { cart: updatedCart });

  return updatedCart;
}

/** Single source of truth: refresh every part of the cart UI from a cart object. */
function updateCartUI(updatedCart) {
  cart = updatedCart;
  renderCartDrawer(updatedCart);
  updateCartCount(updatedCart.item_count);
  updateCartTotals(updatedCart);
  renderDiscounts(updatedCart);
}

function updateCartCount(count) {
  const badge = $('#cart-badge');
  const drawerCount = $('#cart-count-drawer');
  if (badge) {
    badge.textContent = count;
    badge.classList.toggle('cart-badge--hidden', count === 0);
    badge.setAttribute('aria-label', count > 0 ? `${count} items in cart` : 'Cart is empty');
  }
  if (drawerCount) drawerCount.textContent = count;
}

function updateCartTotals(updatedCart) {
  const totalEl = $('#cart-total');
  const checkoutTotalEl = $('#checkout-total');
  const formatted = formatMoney(updatedCart.total_price);
  if (totalEl) totalEl.innerHTML = formatted;
  if (checkoutTotalEl) checkoutTotalEl.innerHTML = formatted;

  const savings = $('#cart-savings');
  const savingsAmount = $('#cart-savings-amount');
  const discount = updatedCart.total_discount || 0;
  if (savings) savings.classList.toggle('cart-savings--hidden', discount === 0);
  if (savingsAmount) savingsAmount.innerHTML = '−' + formatMoney(discount);
  reconvertCurrency();
}

// ---- Discounts ----
/** Codes Shopify currently accepts for this cart. */
function appliedDiscountCodes(c) {
  return (c.discount_codes || []).filter(d => d.applicable).map(d => d.code);
}

/** Replace the cart's discount set (comma separated, '' clears all). */
async function setCartDiscounts(codeString) {
  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ discount: codeString })
  });
  if (!res.ok) throw new Error('Could not update discounts');
  return res.json();
}

async function applyDiscountCode(code) {
  const existing = appliedDiscountCodes(cart);
  const attempt = [...new Set([...existing, code])];
  let updated = await setCartDiscounts(attempt.join(','));

  const accepted = (updated.discount_codes || [])
    .some(d => d.code.toLowerCase() === code.toLowerCase() && d.applicable);

  if (!accepted) {
    // Drop the rejected code so it doesn't linger; keep whatever still applies.
    updated = await setCartDiscounts(appliedDiscountCodes(updated).join(','));
    updateCartUI(updated);
    dispatch('cart:updated', { cart: updated });
    throw new Error(`“${code}” is not a valid code for your cart.`);
  }

  updateCartUI(updated);
  dispatch('cart:updated', { cart: updated });
  return updated;
}

async function removeDiscountCode(code) {
  const keep = appliedDiscountCodes(cart).filter(c => c.toLowerCase() !== code.toLowerCase());
  const updated = await setCartDiscounts(keep.join(','));
  updateCartUI(updated);
  dispatch('cart:updated', { cart: updated });
  return updated;
}

function renderDiscounts(c) {
  const list = $('#discount-applied');
  if (!list) return;
  const codes = appliedDiscountCodes(c);
  list.innerHTML = codes.map(code => `
    <li class="cart-discount__chip">
      <span>${escapeHtml(code)}</span>
      <button type="button" class="cart-discount__remove" data-code="${escapeHtml(code)}" aria-label="Remove discount ${escapeHtml(code)}">&times;</button>
    </li>`).join('');
}

/** Insert a Shopify CDN size suffix before the file extension, preserving query strings. */
function sizedImage(url, size) {
  if (!url) return '';
  return url.replace(/(\.(?:jpe?g|png|gif|webp))(\?|$)/i, `_${size}$1$2`);
}

function buildCartItemHTML(item) {
  const imgSrc = sizedImage(item.image, '160x200_crop_center');

  const variant = item.variant_title && item.variant_title !== 'Default Title'
    ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>`
    : '';

  const discounts = (item.line_level_discount_allocations || []).length
    ? `<ul class="cart-item__discounts" role="list">${item.line_level_discount_allocations
        .map(a => `<li>${escapeHtml(a.discount_application.title)} (&minus;${formatMoney(a.amount)})</li>`)
        .join('')}</ul>`
    : '';

  const price = item.original_line_price > item.final_line_price
    ? `<span class="cart-item__price-was">${formatMoney(item.original_line_price)}</span><span class="cart-item__price-now">${formatMoney(item.final_line_price)}</span>`
    : formatMoney(item.final_line_price);

  return `
    <div class="cart-item" data-key="${item.key}">
      <a href="${item.url}" class="cart-item__image" aria-label="${escapeHtml(item.product_title)}">
        ${imgSrc ? `<img src="${imgSrc}" alt="${escapeHtml(item.title)}" loading="lazy" width="80" height="100">` : ''}
      </a>
      <div class="cart-item__info">
        <a href="${item.url}" class="cart-item__name">${escapeHtml(item.product_title)}</a>
        ${variant}
        ${discounts}
        <div class="cart-item__qty" role="group" aria-label="Quantity">
          <button class="qty-btn" data-action="decrease" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Decrease">
            <svg width="10" height="2" viewBox="0 0 10 2" aria-hidden="true"><path d="M0 1h10" stroke="currentColor" stroke-width="1.5"/></svg>
          </button>
          <span class="qty-value" aria-live="polite">${item.quantity}</span>
          <button class="qty-btn" data-action="increase" data-key="${item.key}" data-qty="${item.quantity}" aria-label="Increase">
            <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M5 0v10M0 5h10" stroke="currentColor" stroke-width="1.5"/></svg>
          </button>
        </div>
        <button class="cart-item__remove" data-action="remove" data-key="${item.key}" aria-label="Remove ${escapeHtml(item.product_title)}">Remove</button>
      </div>
      <div class="cart-item__price">${price}</div>
    </div>`;
}

function renderCartDrawer(updatedCart) {
  const body = $('#cart-drawer-body');
  if (!body) return;

  if (updatedCart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <p>Your cart is empty.</p>
        <a href="/collections/all" class="btn btn--outline-dark">Start Shopping</a>
      </div>`;
    return;
  }

  body.innerHTML = `<div class="cart-items" id="cart-items">${
    updatedCart.items.map(buildCartItemHTML).join('')
  }</div>`;
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// ============================================================
// PRODUCT FORM — ADD TO CART
// ============================================================
function initProductForms() {
  document.querySelectorAll('[data-product-form]').forEach(form => {
    on(form, 'submit', async e => {
      e.preventDefault();
      const variantSelect = form.querySelector('[id^="variant-select-"]');
      const addBtn = form.querySelector('[data-add-to-cart]');
      const variantId = variantSelect?.value;
      if (!variantId || !addBtn) return;

      const btnText = addBtn.querySelector('.btn-text');
      addBtn.disabled = true;
      if (btnText) btnText.textContent = 'Adding...';

      try {
        await addToCart(variantId);
        const updatedCart = await fetchCart();
        updateCartUI(updatedCart);

        if (btnText) btnText.textContent = 'Added!';

        // Label to return to (pre-order keeps its own label)
        const defaultLabel = addBtn.dataset.preorder === 'true'
          ? (addBtn.dataset.preorderLabel || 'PRE-ORDER')
          : 'ADD TO CART';

        // Fire events apps listen for (e.g., Klaviyo, analytics)
        dispatch('product:added', { variantId, cart: updatedCart });
        dispatch('cart:updated', { cart: updatedCart });

        setTimeout(() => {
          if (btnText) btnText.textContent = defaultLabel;
          addBtn.disabled = false;
        }, 1600);

        // Open cart drawer
        if (window.openCartDrawer) window.openCartDrawer();

      } catch (err) {
        if (btnText) btnText.textContent = err.message || 'Error — Try again';
        addBtn.disabled = false;
        const defaultLabel = addBtn.dataset.preorder === 'true'
          ? (addBtn.dataset.preorderLabel || 'PRE-ORDER')
          : 'ADD TO CART';
        setTimeout(() => {
          if (btnText) btnText.textContent = defaultLabel;
        }, 3000);
      }
    });
  });
}

// ============================================================
// PRODUCT OPTIONS — VARIANT SELECTOR
// ============================================================
function initVariantSelectors() {
  const productPage = $('#product-main');
  if (!productPage) return;

  const product = window.productJSON;
  if (!product) return;

  const variantSelect = productPage.querySelector('[id^="variant-select-"]');
  if (!variantSelect) return;

  function getSelectedOptions() {
    const opts = {};
    productPage.querySelectorAll('[data-option-index]').forEach(wrap => {
      const idx = parseInt(wrap.dataset.optionIndex, 10);
      const activeBtn = wrap.querySelector('.option-btn--active');
      if (activeBtn) opts[idx] = activeBtn.dataset.value;
    });
    return opts;
  }

  function findVariant(selectedOpts) {
    return product.variants.find(v => {
      return Object.keys(selectedOpts).every((pos, i) => {
        return v.options[parseInt(pos, 10) - 1] === selectedOpts[pos];
      });
    });
  }

  function updateVariantUI(variant) {
    if (!variant) return;

    // Update hidden select
    variantSelect.value = variant.id;
    variantSelect.dataset.variantId = variant.id;

    // Show the matching pre-rendered price (already converted by the currency app on load)
    const priceWrap = $('#product-price');
    if (priceWrap) {
      const variants = priceWrap.querySelectorAll('.product-details__price-variant');
      if (variants.length) {
        variants.forEach(el => { el.hidden = el.dataset.variantId !== String(variant.id); });
      } else {
        // Fallback for single-variant products
        priceWrap.innerHTML = formatMoney(variant.price);
        reconvertCurrency();
      }
    }

    // Update add to cart button. Pre-order respects stock: it only relabels the button
    // while the variant is in stock; at 0 stock it falls back to SOLD OUT.
    const addBtn = productPage.querySelector('[data-add-to-cart]');
    const btnText = addBtn?.querySelector('.btn-text');
    const isPreorder = addBtn && addBtn.dataset.preorder === 'true';
    const preorderLabel = (addBtn && addBtn.dataset.preorderLabel) || 'PRE-ORDER';
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.setAttribute('aria-disabled', String(!variant.available));
    }
    if (btnText) {
      btnText.textContent = variant.available ? (isPreorder ? preorderLabel : 'ADD TO CART') : 'SOLD OUT';
    }

    // Hide the pre-order note when the selected variant is sold out
    const preNote = productPage.querySelector('.product-preorder-note');
    if (preNote) preNote.hidden = !(isPreorder && variant.available);

    // Keep the "Buy it now" / dynamic checkout button visible but non-clickable when sold out
    const submitWrap = addBtn?.closest('.product-form__submit-wrap');
    if (submitWrap) {
      submitWrap.classList.toggle('is-sold-out', !variant.available);
      const dcWrap = submitWrap.querySelector('.dynamic-checkout-wrap');
      if (dcWrap) dcWrap.setAttribute('aria-hidden', String(!variant.available));
    }

    // Update URL without reload (preserves back button behavior)
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({ variantId: variant.id }, '', url.toString());

    // Fire variant change events — listened to by reviews, wishlist, upsell apps
    dispatch('variant:changed', { variant, product }, productPage);
    dispatch('variantChanged', { variant, product });

    // Shopify-compatible event
    document.dispatchEvent(new CustomEvent('shopify:section:variant-changed', {
      bubbles: true,
      detail: { variant, product, sectionId: productPage.dataset.sectionId }
    }));
  }

  // Option button clicks
  on(productPage, 'click', e => {
    const btn = e.target.closest('.option-btn');
    if (!btn || btn.dataset.soldOut === 'true') return;

    const wrap = btn.closest('[data-option-index]');
    if (!wrap) return;

    // Update active state
    wrap.querySelectorAll('.option-btn').forEach(b => {
      b.classList.remove('option-btn--active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('option-btn--active');
    btn.setAttribute('aria-pressed', 'true');

    // Update selected label
    const pos = wrap.dataset.optionIndex;
    const sectionId = productPage.dataset.sectionId;
    const selectedSpan = productPage.querySelector(`#selected-opt-${pos}-${sectionId}`);
    if (selectedSpan) selectedSpan.textContent = btn.dataset.value;

    const variant = findVariant(getSelectedOptions());
    if (variant) updateVariantUI(variant);
  });
}

// ============================================================
// PRODUCT GALLERY
// ============================================================
function initProductGallery() {
  const gallery = $('#product-gallery');
  if (!gallery) return;

  const thumbs = $$('.product-gallery__thumb', gallery);
  const slides = $$('.product-gallery__slide', gallery);
  const mainWrap = $('#gallery-main');
  let currentIndex = 0;

  // On mobile the slides are a native scroll-snap carousel; on desktop they toggle via display
  const isCarousel = () => mainWrap && window.matchMedia('(max-width: 768px)').matches;

  function setActive(index) {
    thumbs.forEach((t, i) => {
      t.classList.toggle('product-gallery__thumb--active', i === index);
      t.setAttribute('aria-selected', String(i === index));
    });
    slides.forEach((s, i) => {
      s.classList.toggle('product-gallery__slide--active', i === index);
    });
    currentIndex = index;
  }

  function goTo(index) {
    if (index < 0 || index >= slides.length) return;
    setActive(index);
    if (isCarousel()) {
      mainWrap.scrollTo({ left: index * mainWrap.clientWidth, behavior: 'smooth' });
    }
  }

  thumbs.forEach((thumb, i) => on(thumb, 'click', () => goTo(i)));

  // Keep the active thumbnail in sync while the user swipes the carousel
  if (mainWrap) {
    let scrollTimer;
    on(mainWrap, 'scroll', () => {
      if (!isCarousel()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const idx = Math.round(mainWrap.scrollLeft / mainWrap.clientWidth);
        const clamped = Math.max(0, Math.min(idx, slides.length - 1));
        if (clamped !== currentIndex) setActive(clamped);
      }, 80);
    }, { passive: true });
  }

  // Keyboard navigation on thumbnails
  on(gallery, 'keydown', e => {
    if (e.key === 'ArrowRight') goTo(currentIndex + 1);
    if (e.key === 'ArrowLeft') goTo(currentIndex - 1);
  });

  initLightbox(slides, () => currentIndex);
}

function initLightbox(slides, getCurrentIndex) {
  const zoomBtn = $('#gallery-zoom');
  const lightbox = $('#lightbox');
  const closeBtn = $('#lightbox-close');
  const overlayEl = $('#lightbox-overlay');
  const prevBtn = $('#lightbox-prev');
  const nextBtn = $('#lightbox-next');
  const imgWrap = $('#lightbox-img');
  if (!lightbox || !zoomBtn) return;

  let lbIndex = 0;

  function getHighResSrc(index) {
    const img = slides[index]?.querySelector('img');
    if (!img) return '';
    return img.src.replace(/(_\d+x\d+)/, '_2000x');
  }

  function showAt(index) {
    lbIndex = Math.max(0, Math.min(index, slides.length - 1));
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    imgWrap.innerHTML = `<img src="${getHighResSrc(lbIndex)}" alt="Product image ${lbIndex + 1} of ${slides.length}">`;
    prevBtn.disabled = lbIndex === 0;
    nextBtn.disabled = lbIndex === slides.length - 1;
    closeBtn.focus();
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    zoomBtn.focus();
  }

  on(zoomBtn, 'click', () => showAt(getCurrentIndex()));
  on(closeBtn, 'click', closeLightbox);
  on(overlayEl, 'click', closeLightbox);
  on(prevBtn, 'click', () => showAt(lbIndex - 1));
  on(nextBtn, 'click', () => showAt(lbIndex + 1));

  on(document, 'keydown', e => {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showAt(lbIndex - 1);
    if (e.key === 'ArrowRight') showAt(lbIndex + 1);
  });
}

// ============================================================
// ACCORDION
// ============================================================
function initAccordion() {
  on(document, 'click', e => {
    const btn = e.target.closest('.accordion-btn');
    if (!btn) return;
    const panelId = btn.getAttribute('aria-controls');
    const panel = panelId ? $('#' + panelId) : null;
    const isOpen = btn.getAttribute('aria-expanded') === 'true';

    btn.setAttribute('aria-expanded', String(!isOpen));
    if (panel) panel.hidden = isOpen;
  });
}

// ============================================================
// STICKY HEADER
// ============================================================
function initStickyHeader() {
  const wrap = $('#site-header-wrap');
  const header = $('#site-header');
  const isHomepage = document.body.classList.contains('template-index');

  // Keep body padding-top in sync with the fixed header wrap height.
  // On the homepage the hero extends behind the transparent header, so no padding needed.
  function syncPadding() {
    if (!wrap) return;
    document.body.style.paddingTop = isHomepage ? '0' : wrap.offsetHeight + 'px';
  }
  syncPadding();
  window.addEventListener('resize', syncPadding);

  if (header) {
    function updateHeader() {
      const scrolled = window.scrollY > 10;
      header.classList.toggle('is-scrolled', scrolled);
      if (isHomepage) {
        header.classList.toggle('header--transparent', !scrolled);
      }
    }
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }
}

// ============================================================
// COLLECTION FILTERS (native Shopify tag filtering)
// The filter tabs use native Shopify tag URLs — no JS needed for
// the links. The active tab is set server-side via current_tags.
// This JS adds smooth scroll to top after filter.
// ============================================================
function initCollectionFilters() {
  const grid = $('#product-grid');
  if (!grid) return;
  // Nothing to do — native tag links handle filtering via page reload
  // For AJAX filtering, install the Shopify Search & Discovery app
}

// ============================================================
// CART PAGE — QUANTITY CONTROLS
// ============================================================
function initCartPage() {
  const cartForm = $('#cart-page-form');
  if (!cartForm) return;

  on(document, 'click', async e => {
    const btn = e.target.closest('.page-qty-decrease, .page-qty-increase');
    if (!btn) return;
    const key = btn.dataset.key;
    const isIncrease = btn.classList.contains('page-qty-increase');
    const row = btn.closest('.cart-page__item');
    const input = row?.querySelector('.qty-input');
    if (!input) return;

    const current = parseInt(input.value, 10);
    const newQty = isIncrease ? current + 1 : Math.max(0, current - 1);
    input.value = newQty;

    const updatedCart = await updateCartItem(key, newQty);

    // Update page subtotal
    if (newQty === 0) row?.remove();

    // Update cart page totals
    $$('.cart-page__subtotal span').forEach((el, i) => {
      if (i === 1) el.innerHTML = formatMoney(updatedCart.total_price);
    });
    const checkoutBtn = $('.btn--filled.btn--block');
    if (checkoutBtn) checkoutBtn.innerHTML = `Checkout — ${formatMoney(updatedCart.total_price)}`;
    reconvertCurrency();
  });
}

// ============================================================
// THEME EDITOR — Section/block live preview support
// ============================================================
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    // Re-init components when a section is added/reloaded in the editor
    initMegaMenu();
    initMobileMenu();
    initAccordion();
    initProductGallery();
    initVariantSelectors();
    initProductForms();
  });

  document.addEventListener('shopify:section:unload', e => {
    // Cleanup if needed
  });

  document.addEventListener('shopify:block:select', e => {
    // Optionally scroll block into view
    const block = e.target;
    if (block) block.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

// ============================================================
// INIT
// ============================================================
function init() {
  initMegaMenu();
  initMobileMenu();
  initSearch();
  initCountdown();
  initCartDrawer();
  initProductForms();
  initVariantSelectors();
  initProductGallery();
  initAccordion();
  initStickyHeader();
  initCollectionFilters();
  initCartPage();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
